import axios from "axios";
let flgBackend = null;
let baseUrl;

// Control de refresh para evitar múltiples llamadas concurrentes
let isRefreshing = false;
const requestQueue = [];

const enqueueRequest = (cb) => {
  requestQueue.push(cb);
};

const resolveQueuedRequests = (newToken) => {
  while (requestQueue.length > 0) {
    const callback = requestQueue.shift();
    try {
      callback(newToken);
    } catch (_e) {}
  }
};

const refreshAuthToken = async () => {
  const refreshToken = sessionStorage.refreshToken;
  if (!refreshToken) {
    // Redirigir al login si no hay refreshToken
    window.location.href = "/";
    throw new Error("No refresh token available");
  }

  const client = axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
  const REFRESH_ENDPOINT = `${baseUrl}shared/Auth/refresh`; // Ajustar si difiere en backend

  const res = await client.post(REFRESH_ENDPOINT, { refreshToken });
  const newToken = res?.data?.accessToken;
  if (!newToken) throw new Error("No token returned by refresh endpoint");
  sessionStorage.token = newToken;
  if (res?.data?.refreshToken)
    sessionStorage.refreshToken = res.data.refreshToken;
  return newToken;
};

const axiosLogin = async () => {
  if (flgBackend === null) {
    baseUrl = await fetch(`/config.json?v=${new Date().getTime()}`);
    baseUrl = await baseUrl.json();
    baseUrl = await baseUrl.wsLogin;
    flgBackend = true;
  }

  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  // Interceptor de request: siempre toma el token actual del sessionStorage
  axiosInstance.interceptors.request.use((config) => {
    const token = sessionStorage.token;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // Interceptor de respuesta: ante 401 intenta refrescar el token y reintenta
  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, _reject) => {
        resolve(response);
      }),
    async (error) => {
      const originalRequest = error?.config;
      const status = error?.response?.status;

      if (
        status === 401 &&
        !error?.config?.url.includes("legacy-login") && //esto hay que borrarlo despues
        // Endpoints anónimos del QR de informe: un 401 acá es de NEGOCIO (código incorrecto /
        // vencido), NO de sesión → debe propagar al catch del modal, sin refrescar ni redirigir.
        !error?.config?.url.includes("imagen-viewer-qr") &&
        !error?.config?.url.includes("reenviar-codigo-qr") &&
        originalRequest &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        if (!isRefreshing) {
          isRefreshing = true;
          refreshAuthToken()
            .then((newToken) => {
              // Actualiza token para futuros requests
              axiosInstance.defaults.headers.Authorization = `Bearer ${newToken}`;
              resolveQueuedRequests(newToken);
              return newToken;
            })
            .catch((refreshErr) => {
              resolveQueuedRequests(null);
              // Si el error es por falta de refreshToken, ya se redirigió en refreshAuthToken
              // Si es otro error, también redirigir al login
              if (refreshErr.message !== "No refresh token available") {
                window.location.href = "/";
              }
              throw refreshErr;
            })
            .finally(() => {
              isRefreshing = false;
            });
        }

        return new Promise((resolve, reject) => {
          enqueueRequest((newToken) => {
            if (!newToken) {
              reject(error);
              return;
            }
            // Reintenta con el nuevo token
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }

      return new Promise((_resolve, reject) => {
        reject(error);
      });
    }
  );
  return axiosInstance;
};

export default axiosLogin;
